import React, { useState } from "react";
import api from "../../api/api";
import CloseIcon from '@mui/icons-material/Close';
import { getPracticeId } from '../../config/practice';

const AddDevicesModal = ({
  isOpen,
  setOpenToast,
  setToastMessage,
  fetchdata,
  setToastSeverity,
  onClose,
  
}) => {
  const deviceTypes = [
    { label: "BPP", value: "bpp" },
    { label: "CGM", value: "cgm" },
    { label: "CPAP", value: "cpap" },
    { label: "WLM", value: "wlm" },
    { label: "EKG", value: "ekg" },
  ];

  const loginUser = localStorage.getItem("user");
  const practiseid = getPracticeId();

  // State management for all form fields
  const [serialNumber, setSerialNumber] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [details, setDetails] = useState("");

  const addDevice = async () => {
    try {
      const response = await api.post(`v1/${practiseid}/rpm_devices/create_device`, {
        devicesno: serialNumber,
        devicetype: deviceType,
        created_by: loginUser,
        devicedtls:details,
        deviceno:deviceNumber,
        practiceid:practiseid
      });

      if (response.status === 200) {
        setToastMessage(response.message || "Device added successfully.");
        setToastSeverity("success");
        setOpenToast(true);
        fetchdata();
        onClose(false); // Close the modal after successful submission
      } else {
        setToastMessage(response.message || "Failed to add device.");
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.error("Error adding device:", error);
      setToastMessage("An error occurred while adding the device.");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const handleSave = () => {
    if (!deviceNumber || !deviceType ) {
      setToastMessage("Please fill out all fields.");
      setToastSeverity("warning");
      setOpenToast(true);
      return;
    }
    addDevice();
  };

  return (
    isOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-lg shadow-lg w-[40%]  relative">
          {/* Header with Close Icon */}
          <div className="flex justify-between items-center border-b p-3 bg-[#E1795454]">
            <h2 className="text-lg font-inter">Add Device</h2>
            <button
              className="text-gray-500 hover:text-gray-800"
              onClick={() => onClose(false)}
            >
            <CloseIcon style={{width:"22px"}}/>
            </button>
          </div>

          {/* Modal Content */}
          <form className="grid grid-cols-2 gap-4 mt-4 text-start px-4">
            {/* Serial No */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Serial No
              </label>
              <input
                type="text"
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                placeholder="Enter Serial No"
                value={serialNumber}
                onChange={(e) => setSerialNumber(e.target.value)}
              />
            </div>

            {/* Device No */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Device No(Email)
              </label>
              <input
                type="text"
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                placeholder="Enter Device No"
                value={deviceNumber}
                onChange={(e) => setDeviceNumber(e.target.value)}
              />
            </div>

            {/* Type (Dropdown) */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Type
              </label>
              <select
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                value={deviceType}
                onChange={(e) => setDeviceType(e.target.value)}
              >
                <option value="" disabled>
                  Select Type
                </option>
                {deviceTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Details */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Details
              </label>
              <input
                type="text"
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
                placeholder="Enter Details"
                value={details}
                onChange={(e) => setDetails(e.target.value)}
              />
            </div>
          </form>

          {/* Footer Buttons */}
          <div className="flex justify-end mt-6 space-x-2 p-3">
            <button
              className="px-4 py-2 border-[1.5px] border-gray-200  rounded-md "
              onClick={() => onClose(false)}
            >
              Close
            </button>
            <button
              className="px-4 py-2 bg-[#E17954] text-white rounded-md hover:bg-blue-600"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default AddDevicesModal;
